import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminPageHeader } from "./_helpers";

export default function AdminNewsTips() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => api.get(`/news-tips${filter ? `?status=${filter}` : ""}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [filter]);
  return (
    <div>
      <AdminPageHeader title="Haber Hattı Gelen Kutusu" />
      <div className="flex gap-2 mb-3">
        {["", "pending", "approved", "rejected"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded text-sm ${filter === s ? "bg-[#e11d2a] text-white" : "border"}`}>{s || "Tümü"}</button>
        ))}
      </div>
      <div className="bg-white border border-gray-100 rounded-lg">
        {items.map((t) => (
          <div key={t.id} className="p-4 border-b last:border-0">
            <div className="flex items-center justify-between">
              <div className="font-semibold">{t.title}</div>
              <span className={`text-xs px-2 py-0.5 rounded ${t.status === "pending" ? "bg-amber-100" : t.status === "approved" ? "bg-emerald-100" : "bg-red-100"}`}>{t.status}</span>
            </div>
            <div className="text-sm text-gray-600 mt-1 whitespace-pre-wrap">{t.description}</div>
            {t.contact_phone && <div className="text-xs text-gray-500 mt-1">İletişim: {t.contact_name} — {t.contact_phone} {t.contact_email && `— ${t.contact_email}`}</div>}
            {t.status === "pending" && (
              <div className="mt-2 flex gap-2">
                <button onClick={async () => { await api.post(`/news-tips/${t.id}/approve`); load(); }} className="text-xs px-3 py-1 bg-emerald-600 text-white rounded">Onayla</button>
                <button onClick={async () => { await api.post(`/news-tips/${t.id}/reject`); load(); }} className="text-xs px-3 py-1 bg-red-600 text-white rounded">Reddet</button>
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="p-8 text-center text-gray-500 text-sm">Henüz ihbar yok</div>}
      </div>
    </div>
  );
}
